import TagManager from 'react-gtm-module'

const useTracking = () => {
    const FS = window['FS']

    const anonymize = () => {
        if (FS) {
            FS.anonymize()
        }
    }

    const sha256 = async function (input) {
        const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(input));
        return Array.from(new Uint8Array(buf))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
    }

    const identifyUser = async (id, email) => {
        if (id) {
            const normalizedEmail = (email || '').trim().toLowerCase();
            const hashedEmail = normalizedEmail ? await sha256(normalizedEmail) : null;

            TagManager.dataLayer({
                dataLayer: {
                    opCustomerId: id,
                    user_id: hashedEmail,
                },
            })
            if (FS) {
                FS.identify(id)
            }
        }
    }

    const init = (gtmContainer) => {
        if (typeof navigator.webdriver === 'undefined') {
            TagManager.initialize({ gtmId: gtmContainer })
        }
    }

    return { anonymize, identifyUser, init }
}

export default useTracking
